import ExtendStore from 'src/stores/base/extendStore';
import { action, observable, runInAction } from 'mobx';
import ManageCenterStore from "../../manageCenterStore";
import { Stores } from 'src/stores';
import manageCenterApi from 'src/apis/manageCenterApi';
import zhejiangApi from 'src/custom/zhejiang/apis/zhejiangApi';
import manageCenterTypes from 'src/types/manageCenterTypes';
import { message } from 'antd';
import { commonUtil } from 'mam-common-utils';
import _ from 'lodash';


export default class HotPerson extends ExtendStore {
    @observable
    public personType: manageCenterTypes.hotPerson.IpersonDataTypes[] = []
    @observable
    public personAvatarData: string[] = []
    @observable
    public selectPersonData: manageCenterTypes.hotPerson.IselectPersonDataTypes = {
        index: -1,
        type: '',
        frame_path: ''
    }
    @observable
    public newsPersonData: manageCenterTypes.hotPerson.InewsPersonDataTypes[] = []
    @observable
    public hotPersonData1: manageCenterTypes.hotPerson.IhotPersonDataTypes[] = []
    @observable
    public hotPersonData1old: manageCenterTypes.hotPerson.IhotPersonDataTypes[] = []
    @observable
    public hotPersonData2: manageCenterTypes.hotPerson.IhotPersonDataTypes[] = []
    @observable
    public hotPersonData2old: manageCenterTypes.hotPerson.IhotPersonDataTypes[] = []
    @observable
    public hotPersonTotal: manageCenterTypes.hotPerson.IhotPersonTotalTypes = { total1: 0, total2: 0 }

    private manageCenterStore: ManageCenterStore
    public constructor(stores: Stores, manageCenterStore: ManageCenterStore) {
        super(stores)
        this.manageCenterStore = manageCenterStore
    }

    @action
    public setPersonAvatarData = (value: string[]) => {
        this.personAvatarData = value
    }

    @action
    public setSelectPersonData = (typeName: string, value: any) => {
        this.selectPersonData[typeName] = value
    }

    @action
    public deleteNewsPersonData = (index: number) => {
        if (this.newsPersonData.length > 1) {
            _.remove(this.newsPersonData, (value, indexs, array) => {
                return indexs === index
            });
            this.setNewsPersonData(commonUtil.copyObj(this.newsPersonData))
        }
    }

    @action
    public replacesNewsPersonData = (name: string) => {
        this.newsPersonData[this.selectPersonData.index].name = name
        this.newsPersonData[this.selectPersonData.index].icon_path = this.selectPersonData.frame_path
        this.setNewsPersonData(commonUtil.copyObj(this.newsPersonData))
    }

    @action
    public deleteHotPersonData1 = (index: number) => {
        if (this.hotPersonData1.length > 1) {
            _.remove(this.hotPersonData1, (value, indexs, array) => {
                return indexs === index
            });
            this.setHotPersonData1(commonUtil.copyObj(this.hotPersonData1))
        }
    }

    @action
    public replacesHotPersonData1 = (name: string) => {
        this.hotPersonData1[this.selectPersonData.index].name = name
        this.hotPersonData1[this.selectPersonData.index].icon_path = this.selectPersonData.frame_path
        this.setHotPersonData1(commonUtil.copyObj(this.hotPersonData1))
    }

    @action
    public deleteHotPersonData2 = (index: number) => {
        if (this.hotPersonData2.length > 1) {
            _.remove(this.hotPersonData2, (value, indexs, array) => {
                return indexs === index
            });
            this.setHotPersonData2(commonUtil.copyObj(this.hotPersonData2))
        }
    }

    @action
    public replacesHotPersonData2 = (name: string) => {
        this.hotPersonData2[this.selectPersonData.index].name = name
        this.hotPersonData2[this.selectPersonData.index].icon_path = this.selectPersonData.frame_path
        this.setHotPersonData2(commonUtil.copyObj(this.hotPersonData2))
    }

    @action
    public setNewsPersonData = (data: manageCenterTypes.hotPerson.InewsPersonDataTypes[]) => {
        this.newsPersonData = data
    }

    @action
    public setHotPersonData1 = (data: manageCenterTypes.hotPerson.IhotPersonDataTypes[]) => {
        this.hotPersonData1 = data
    }
    @action
    public setHotPersonData2 = (data: manageCenterTypes.hotPerson.IhotPersonDataTypes[]) => {
        this.hotPersonData2 = data
    }

    @action
    public getPersonType = () => {
        return new Promise((resolve, reject) => {
            manageCenterApi.hotPerson.getPersonType().then(res => {
                runInAction(() => {
                    if (res.status === 200 && res.data.data) {
                        this.personType = res.data.data
                    }
                })
            }).catch((res) => {
                if (res.data.error && res.data.error.title) {
                    message.error(res.data.error.title)
                }
            })
        })
    }

    @action
    public getPersonAvatarData = (value: manageCenterTypes.hotPerson.IparmsTypes) => {
        return new Promise((resolve, reject) => {
            manageCenterApi.hotPerson.getPersonData(value).then(res => {
                runInAction(() => {
                    if (res.status === 200 && res.data.data && res.data.data.data[0] && res.data.data.data[0].picture_paths) {
                        this.personAvatarData = res.data.data.data[0].picture_paths
                    }
                })
            }).catch((res) => {
                if (res.data.error && res.data.error.title) {
                    message.error(res.data.error.title)
                }
            })
        })
    }

    @action
    public getNewsPersonData = () => {
        return new Promise((resolve, reject) => {
            zhejiangApi.queryStatistics('newspage_hot_person').then(res => {
                runInAction(() => {
                    if (res.data.success && res.data.data) {
                        this.newsPersonData = res.data.data.statistics_result
                    }
                })
            }).catch((res) => {
                if (res.data.error && res.data.error.title) {
                    message.error(res.data.error.title)
                }
            })
        })
    }

    @action
    public getHomePersonData = () => {
        return new Promise((resolve, reject) => {
            zhejiangApi.queryStatistics('homepage_important_person').then(res => {
                runInAction(() => {
                    if (res.data.success && res.data.data) {
                        let obj = res.data.data.statistics_result
                        if (obj.country) {
                            this.hotPersonData1 = obj.country.person
                            this.hotPersonData1old = obj.country.person
                            this.hotPersonTotal.total1 = obj.country.total
                        }
                        if (obj.zhejiang) {
                            this.hotPersonData2 = obj.zhejiang.person
                            this.hotPersonData2old = obj.zhejiang.person
                            this.hotPersonTotal.total2 = obj.zhejiang.total
                        }
                    }
                })
            }).catch((res) => {
                if (res.data.error && res.data.error.title) {
                    message.error(res.data.error.title)
                }
            })
        })
    }

    @action
    public updatePersonData = (data: any) => {
        return new Promise((resolve, reject) => {
            manageCenterApi.hotPerson.updatePersonData(data).then((res) => {
                if(res.data.success){
                    message.success("发布成功！")
                    this.getNewsPersonData()
                    this.getHomePersonData()
                }
            }).catch((res) => {
                if (res.data.error && res.data.error.title) {
                    message.error(res.data.error.title)
                }
            })
        })
    }

}